import React from 'react'
import { Button, Form, Space, Typography } from 'antd-v4'
import { PlusOutlined } from '@ant-design/icons'
import { ILocationZoneContract } from '@getgreenline/blaze-ecomm'
import { CurrencyInput } from '../../../../components/CurrencyInput'
import { ConfigureEcomDelivery } from './ConfigureEcomDelivery'
import { DeliveryZoneCollapse } from './DeliveryZoneCollapse'
import { DeliveryZoneInputGroup } from './DeliveryZoneInputGroup'

interface LocationZoneToolbarProps {
  activeKeys: ConfigureEcomDelivery['activeKeys']
  addLocationZone: ConfigureEcomDelivery['addLocationZone']
  toggleActiveKeys: ConfigureEcomDelivery['toggleActiveKeys']
  disabled: boolean
}

interface FlatRateProps {
  flatRateFee: number
  updateFlatRateFee: (flatRateFee: number) => void
  disabled: boolean
}

interface DeliveryZoneCollapseProps {
  index: number
  locationZone: ILocationZoneContract
  configureEcomDelivery: ConfigureEcomDelivery
  disabled: boolean
}

export const ConfigureEcomDeliveryComponent = {
  LocationZoneToolbar: (locationZoneToolbarProps: LocationZoneToolbarProps) => {
    const ref = React.useRef<HTMLElement>(null)

    return (
      <Space className='configure-ecom-delivery-modal__toolbar' direction='horizontal'>
        <Button
          ref={ref}
          disabled={locationZoneToolbarProps.disabled}
          icon={<PlusOutlined translate='yes' />}
          onClick={() => {
            locationZoneToolbarProps.addLocationZone()
            ref.current?.blur()
          }}
        >
          <span>Add zone</span>
        </Button>
        <Button
          style={{ width: 100 }}
          disabled={locationZoneToolbarProps.disabled}
          type='link'
          onClick={locationZoneToolbarProps.toggleActiveKeys}
        >
          {locationZoneToolbarProps.activeKeys.length > 0 ? 'Collapse all' : 'Expand all'}
        </Button>
      </Space>
    )
  },

  FlatRate: (flatRateProps: FlatRateProps) => (
    <Form.Item
      label='Fee'
      name='flatRateFee'
      initialValue={flatRateProps.flatRateFee}
      rules={[{ required: true, message: 'Please enter your fee' }]}
    >
      <Space size='middle' className='delivery-zone-input-group'>
        <Typography.Paragraph className='delivery-zone-text-description' type='secondary'>
          The price of your delivery fee
        </Typography.Paragraph>
        <CurrencyInput
          disabled={flatRateProps.disabled}
          name='flatRateFee'
          className='form-control delivery-zone-input'
          centValue={flatRateProps.flatRateFee}
          onChange={flatRateProps.updateFlatRateFee}
          onlyPositiveNumber
        />
      </Space>
    </Form.Item>
  ),

  PostalCode: (postalCodeProps: DeliveryZoneCollapseProps) => (
    <DeliveryZoneCollapse
      index={postalCodeProps.index}
      locationZone={postalCodeProps.locationZone}
      configureEcomDelivery={postalCodeProps.configureEcomDelivery}
      disabled={postalCodeProps.disabled}
    >
      <DeliveryZoneInputGroup
        index={postalCodeProps.index}
        locationZone={postalCodeProps.locationZone}
        configureEcomDelivery={postalCodeProps.configureEcomDelivery}
      />
    </DeliveryZoneCollapse>
  ),

  KML: (kmlProps: DeliveryZoneCollapseProps) => (
    <DeliveryZoneCollapse
      index={kmlProps.index}
      locationZone={kmlProps.locationZone}
      configureEcomDelivery={kmlProps.configureEcomDelivery}
      disabled={kmlProps.disabled}
    >
      <DeliveryZoneInputGroup
        index={kmlProps.index}
        locationZone={kmlProps.locationZone}
        configureEcomDelivery={kmlProps.configureEcomDelivery}
      />
    </DeliveryZoneCollapse>
  ),
}
